
import $ from 'jquery';

export function changeSorting(field, order) {
    // Regex to match in URL.
    const sortfieldRegex = /\/sortfield-([^\/]*)/g;
    const sortorderRegex = /\/sortorder-([^\/]*)/g;

    // Get current URL Path.
    const url = new URL( location.href );
    let path  = url.pathname;

    // Replace sortfield and sortorder.
    path = path.replace(sortfieldRegex, '/sortfield-' + field);
    path = path.replace(sortorderRegex, '/sortorder-' + order);

    // Add sortfield if not exist.
    if ( ! path.match( sortfieldRegex ) ) {
        path += 'sortfield-' + field + '/';
    }

    // Add sortorder if not exist.
    if ( ! path.match( sortorderRegex ) ) {
        path += 'sortorder-' + order + '/';
    }

    // Location ends with a Slash?
    if ( ! path.match( /\/$/g ) ) {
        path += '/';
    }

    // Remove default bestseller sorting from url.
    url.pathname = path.replace( 'sortfield-bestseller/sortorder-asc/', '' );
    window.location.href = url.toString();
}

//moved from sorting_list.tpl
$(document).ready(function() {
    // bind change event to select
    $('.acl_sort_select').on( 'change', function () { // bind change event to select
        if ( $(this).attr('id') !== 'sort_select_18' ) {
            var sorting = $(this).find(':selected').data('sorting');
            var order = $(this).find(':selected').data('order');
            if ( sorting ) {
                changeSorting(sorting, order);
            }
            return false;
        }
    });
});

$( document ).ready( function() {
    const $productList = $('#product-list');

    // Move products to front of $productList.
    $productList.children().each(function() {

        const eecId = this.getAttribute('data-eec-id');
        if ( [ 'KOEW201300', 'gs01005' ].includes( eecId ) ) {
            $(this).prependTo($productList);
        }
    })
});